import type { BlocksUser } from "@/src/models/user.model";

const ROLE_PRIORITY = ["super-admin", "admin"] as const;

export const getPrimaryRole = (roles?: readonly string[] | null): string => {
  if (!roles?.length) return "user";
  const normalized = roles.map((r) => r.toLowerCase());
  for (const priorityRole of ROLE_PRIORITY) {
    if (normalized.includes(priorityRole)) return priorityRole;
  }
  return roles[0];
};

export const getUserOrgRoles = (
  blocksUser: BlocksUser,
  orgId?: string,
): string[] => {
  const membership = blocksUser?.memberships?.find(
    (m) => m.organizationId === orgId,
  );
  // De-dupe defensively, case-insensitively, while preserving original casing.
  const seen = new Set<string>();
  return (membership?.roles ?? []).filter((role) => {
    const key = role.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
